import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { jackpotHistoryDetailsApi } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { DATE_FORMAT } from "helpers/common";
import { FadeLoader } from "react-spinners";

export default function JackpotHistoryModal({ show, handleClose, title, id }) {
  const { loading } = useSelector(({ Jackpot }) => Jackpot);
  const [data, setData] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  const fetchData = async () => {
    dispatch(
      jackpotHistoryDetailsApi({
        data: { _id: id },
        callBack: async (err, response) => {
          const game = response?.data;
          if (game?._id) {
            try {
              setData(game);
            } catch (err) {
              console.error("error inside try useEffetc", err);
            }
          }
        },
      }),
    );
  };

  const status = {
    active: "Active",
    completed: "Completed",
    ended: "Ended",
  };

  return loading ? (
    <div className="main-loader">
      <FadeLoader size={1000} />
    </div>
  ) : (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header className="py-3 text-dark" closeButton>
        {/* <Modal.Title className="fw-bold text-dark">{title}</Modal.Title> */}
      </Modal.Header>

      <Modal.Body>
        <>
          <section className="section">
            <div className="section-header">
              <h1>Jackpot Details</h1>
            </div>
            {/* {data?.userDetails?.adminNote ?
              <p>
                <b>
                  Note: </b> <span>{data?.userDetails?.adminNote}</span>
              </p>
              : ""} */}
            <div className="section-body">
              <div className="card">
                <Row>
                  <Col lg="12" className="my-2 px-4">
                    {/* <h4 className="text-primary">Match Details</h4> */}
                    <ul className="list-unstyled ps-0 mb-0 mt-3 row">
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className=" ">
                          JackpotID :{" "}
                          <span className="font-weight-bold">
                            {data?.jackpotID || "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Telegram Username :{" "}
                          <span className="font-weight-bold">
                            {data?.userDetails?.telegram_username || "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          First name :{" "}
                          <span className="font-weight-bold">
                            {data?.userDetails?.first_name || "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Last name :{" "}
                          <span className="font-weight-bold">
                            {data?.userDetails?.last_name || "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Email :{" "}
                          <span className="font-weight-bold">
                            {data?.userDetails?.telegramId ||
                              data?.userDetails?.email}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Energy Won :{" "}
                          <span className="font-weight-bold">
                            {data?.wonEnergy || 0}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          BTNC Won :{" "}
                          <span className="font-weight-bold">
                            {data?.wonBtnc || 0}
                          </span>
                        </p>
                      </li>

                      {data?.wonJackpot && (
                        <>
                          <li className="col-lg-4 col-sm-6 my-2">
                            <p className="">
                              Jackpot Type Won :{" "}
                              <span className="font-weight-bold">
                                {data?.jackpotType?.toUpperCase() || ""}
                              </span>
                            </p>
                          </li>
                          <li className="col-lg-4 col-sm-6 my-2">
                            <p className="">
                              Amount Won :{" "}
                              <span className="font-weight-bold">
                                $ {data?.wonAmount || 0}
                              </span>
                            </p>
                          </li>
                        </>
                      )}
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Status :{" "}
                          <span className="font-weight-bold">
                            {data?.status ? status[data?.status] : "--"}
                          </span>
                        </p>
                      </li>
                      {/* {data?.status === "active" ?
                        <li className="col-lg-4 col-sm-6 my-2">
                          <Button onClick={() => onEndGame()}
                            className="btn">
                            {loadingEndGame && <Spinner size="sm" className="mr-2" />}End Game</Button>
                        </li>
                        : null} */}
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Started At :{" "}
                          <span className="font-weight-bold">
                            {data?.date_created_utc
                              ? DATE_FORMAT(data?.date_created_utc)
                              : "--"}
                          </span>
                        </p>
                      </li>

                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Completed At :{" "}
                          <span className="font-weight-bold">
                            {data?.completedAt
                              ? DATE_FORMAT(data?.completedAt)
                              : "--"}
                          </span>
                        </p>
                      </li>

                      {/* <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Ended At :{" "}
                          <span className="font-weight-bold">
                            {data?.endedAt ? DATE_FORMAT(data?.endedAt) : "--"}
                          </span>
                        </p>
                      </li> */}
                    </ul>
                  </Col>
                  <Col lg="12" className="my-2">
                    <h4 className="text-primary px-2">Jackpot Details</h4>
                    <div className="array-container">
                      {data?.potData?.map((item, index) => (
                        <div key={index} className="array-row">
                          <p className="mt-3 mr-3" style={{ width: 20 }}>
                            {data?.potData?.length - index}
                          </p>
                          {(item || ["", "", ""]).map((cell, cellIndex) => (
                            <p
                              key={cellIndex}
                              className={`array-cell background-${cell?.isOpened} ${cell?.type}`}
                            >
                              {cell?.type?.toLowerCase() === "bomb" && (
                                <img
                                  className={"leaderboard-icon"}
                                  src={cell?.icon}
                                />
                              )}
                              {(cell?.type?.toLowerCase() === "btnc" ||
                                cell?.type?.toLowerCase() === "energy") && (
                                <>
                                  <span className="me-1">{cell.value}</span>
                                  <img
                                    className={"leaderboard-icon"}
                                    style={{ height: 28 }}
                                    src={cell?.icon}
                                  />
                                </>
                              )}
                              {(cell?.type?.toLowerCase() === "grand" ||
                                cell?.type?.toLowerCase() === "major" ||
                                cell?.type?.toLowerCase() === "minor") && (
                                <>
                                  <span className="me-1">
                                    {cell?.type?.toUpperCase()}
                                  </span>
                                  <img
                                    className={"leaderboard-icon"}
                                    style={{ height: 28 }}
                                    src={cell?.icon}
                                  />
                                </>
                              )}
                            </p>
                          ))}
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </section>
        </>
      </Modal.Body>
    </Modal>
  );
}
